var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "transition",
        {
          attrs: {
            name: "bounce",
            "enter-active-class": "slideInUp",
            "leave-active-class": "slideOutDown"
          }
        },
        [
          _vm.message
            ? _c("div", { staticClass: "section-login-alert text-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "box-login-alert",
                    on: {
                      click: function($event) {
                        return _vm.setMessage(null)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.message))]
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f2f4589", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2f4589","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/LoginAlert.vue
// module id = 1443
// module chunks = 0